import { HttpMethod, Type } from "@/Utils/request/types";

import {
  LabLabelsResponse,
  LabReportInfo,
  Letterhead,
  ReportMessage,
  ReportMessagesResponse,
  ReportVerification,
  WhatsappConsent,
} from "./labReports";

export default {
  getLetterhead: {
    path: "/api/v1/facility/{facilityId}/letterhead/",
    method: HttpMethod.GET,
    TRes: Type<Letterhead>(),
  },
  saveLetterhead: {
    path: "/api/v1/facility/{facilityId}/letterhead/",
    method: HttpMethod.POST,
    TRes: Type<Letterhead>(),
    TBody: Type<Letterhead>(),
  },
  /** The PDF itself (the request helper returns a Blob for application/pdf) */
  reportPdf: {
    path: "/api/v1/facility/{facilityId}/lab_report/{reportId}/pdf/",
    method: HttpMethod.GET,
    TRes: Type<Blob>(),
  },
  reportInfo: {
    path: "/api/v1/facility/{facilityId}/lab_report/{reportId}/info/",
    method: HttpMethod.GET,
    TRes: Type<LabReportInfo>(),
  },
  /** The sample labels of an order (`?service_request=`) */
  labels: {
    path: "/api/v1/facility/{facilityId}/lab_report/labels/",
    method: HttpMethod.GET,
    TRes: Type<LabLabelsResponse>(),
  },
  /** Plan 28, C4: send the approved report to the patient (again) */
  sendReport: {
    path: "/api/v1/facility/{facilityId}/lab_report/{reportId}/send/",
    method: HttpMethod.POST,
    TRes: Type<ReportMessage & { sent: boolean }>(),
    TBody: Type<{ channel?: "whatsapp" | "sms" }>(),
  },
  reportMessages: {
    path: "/api/v1/facility/{facilityId}/lab_report/{reportId}/messages/",
    method: HttpMethod.GET,
    TRes: Type<ReportMessagesResponse>(),
  },
  /** The WhatsApp consent of a patient (`?patient=`) */
  consent: {
    path: "/api/v1/facility/{facilityId}/lab_report/consent/",
    method: HttpMethod.GET,
    TRes: Type<WhatsappConsent>(),
  },
  /** Public, no login */
  verify: {
    path: "/api/v1/clinova/verify/{code}/",
    method: HttpMethod.GET,
    TRes: Type<ReportVerification>(),
  },
} as const;
